export interface UsState {
  state: string;
  abbr: string;
}

export const STATES: UsState[] = [
  { state: 'Alabama', abbr: 'AL' },
  { state: 'Alaska', abbr: 'AK' },
  { state: 'American Samoa', abbr: 'AS' },
  { state: 'Arizona', abbr: 'AZ' },
  { state: 'Arkansas', abbr: 'AR' },
  { state: 'California', abbr: 'CA' },
  { state: 'Colorado', abbr: 'CO' },
  { state: 'Connecticut', abbr: 'CT' },
  { state: 'Delaware', abbr: 'DE' },
  { state: 'Washington DC', abbr: 'DC' },
  { state: 'Florida', abbr: 'FL' },
  { state: 'Georgia', abbr: 'GA' },
  { state: 'Guam', abbr: 'GU' },
  { state: 'Hawaii', abbr: 'HI' },
  { state: 'Idaho', abbr: 'ID' },
  { state: 'Illinois', abbr: 'IL' },
  { state: 'Indiana', abbr: 'IN' },
  { state: 'Iowa', abbr: 'IA' },
  { state: 'Kansas', abbr: 'KS' },
  { state: 'Kentucky', abbr: 'KY' },
  { state: 'Louisiana', abbr: 'LA' },
  { state: 'Maine', abbr: 'ME' },
  { state: 'Maryland', abbr: 'MD' },
  { state: 'Massachusetts', abbr: 'MA' },
  { state: 'Michigan', abbr: 'MI' },
  { state: 'Minnesota', abbr: 'MN' },
  { state: 'Mississippi', abbr: 'MS' },
  { state: 'Missouri', abbr: 'MO' },
  { state: 'Montana', abbr: 'MT' },
  { state: 'Nebraska', abbr: 'NE' },
  { state: 'Nevada', abbr: 'NV' },
  { state: 'New Hampshire', abbr: 'NH' },
  { state: 'New Jersey', abbr: 'NJ' },
  { state: 'New Mexico', abbr: 'NM' },
  { state: 'New York', abbr: 'NY' },
  { state: 'North Carolina', abbr: 'NC' },
  { state: 'North Dakota', abbr: 'ND' },
  { state: 'Northern Mariana Islands', abbr: 'MP' },
  { state: 'Ohio', abbr: 'OH' },
  { state: 'Oklahoma', abbr: 'OK' },
  { state: 'Oregon', abbr: 'OR' },
  { state: 'Pennsylvania', abbr: 'PA' },
  { state: 'Puerto Rico', abbr: 'PR' },
  { state: 'Rhode Island', abbr: 'RI' },
  { state: 'South Carolina', abbr: 'SC' },
  { state: 'South Dakota', abbr: 'SD' },
  { state: 'Tennessee', abbr: 'TN' },
  { state: 'Texas', abbr: 'TX' },
  { state: 'Utah', abbr: 'UT' },
  { state: 'Vermont', abbr: 'VT' },
  { state: 'Virginia', abbr: 'VA' },
  { state: 'Virgin Islands', abbr: 'VI' },
  { state: 'Washington', abbr: 'WA' },
  { state: 'West Virginia', abbr: 'WV' },
  { state: 'Wisconsin', abbr: 'WI' },
  { state: 'Wyoming', abbr: 'WY' },
];

export const STATES_BY_ABBR: { [key: string]: UsState } = STATES.reduce((acc, stateData: UsState) => {
  return {
    ...acc,
    [stateData.abbr]: stateData,
  };
}, {});
